var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-support",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messages-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5713",
    "data-name": "Group 5713",
    transform: "translate(0 0.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M15.855,3.967V8.715A4.234,4.234,0,0,1,15.7,9.893a3.681,3.681,0,0,1-3.815,2.788H8.715L5.192,15.027a.783.783,0,0,1-1.225-.653V12.682A3.964,3.964,0,0,1,1.1,11.6,3.971,3.971,0,0,1,0,8.715V3.967A3.714,3.714,0,0,1,3.5.023C3.652.012,3.8,0,3.967,0h7.922A3.748,3.748,0,0,1,15.855,3.967Z",
    transform: "translate(2.333 10.5)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M14.875,15.867A4.929,4.929,0,0,0,18.468,14.5a4.929,4.929,0,0,0,1.365-3.593V4.958A4.954,4.954,0,0,0,14.875,0H4.958A4.954,4.954,0,0,0,0,4.958v.875a.578.578,0,0,0,.583.583h7.8a5.711,5.711,0,0,1,5.717,5.717v3.15a.578.578,0,0,0,.583.583Z",
    transform: "translate(5.833 2.334)",
    fill: "#222227"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.7b7e4aec56fb9a6cb21142f9eabb52a1.svg";
export { ForwardRef as ReactComponent };